import createClient from 'openapi-fetch'
import type { paths } from '@/lib/api/schema'
import { apiBaseUrl } from '@/lib/api/url'

export { apiBaseUrl }

/**
 * Typed API client. `paths` is generated from the API's OpenAPI document (paths already
 * carry the /api prefix):  make api-types   (reads the schema from the app; no server needed)
 *
 * Dev: same origin through the Vite proxy, so `VITE_API_BASE_URL` stays unset and the base is ''.
 * Beta: the SPA is on app.ringout.ai (Cloudflare Pages) and the API on api.ringout.ai, so the
 * build sets `VITE_API_BASE_URL=https://api.ringout.ai` (an origin: no trailing slash, no /api).
 * The browser then sends the session cookie cross-origin, which needs `credentials: 'include'`
 * here and an exact allowed origin on the API (CORS, `WEB_BASE_URL`).
 */
export const api = createClient<paths>({ baseUrl: apiBaseUrl(), credentials: 'include' })
